import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop
 * Remet le scroll en haut de la page à chaque changement de route (pathname).
 * À placer à l'intérieur du <BrowserRouter>, avant les <Routes>.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Empêche la restauration automatique du scroll par le navigateur
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    // Remonte tout en haut de la page à chaque nouveau pathname
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    // Sécurité mobile (Safari iOS) : force également le document et body
    if (document.scrollingElement) {
      document.scrollingElement.scrollTop = 0;
    }
    if (document.body) {
      document.body.scrollTop = 0;
    }
  }, [pathname]);

  return null;
}
